import { render, staticRenderFns } from "./BookletPartRead.vue?vue&type=template&id=596fa6d0&scoped=true"
import script from "./BookletPartRead.vue?vue&type=script&lang=js"
export * from "./BookletPartRead.vue?vue&type=script&lang=js"
import style0 from "./BookletPartRead.vue?vue&type=style&index=0&id=596fa6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596fa6d0",
  null
  
)

export default component.exports